export default function Contact() {
  return (
    <section id="contact" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-800 mb-6">연락처 및 오시는 길</h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            고흥꿈트리 치유마을로 오시는 길과 연락처 정보입니다
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div className="space-y-8">
            <div>
              <h4 className="text-2xl font-bold text-gray-800 mb-6">연락처 정보</h4>
              
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-green-600 text-xl"></i>
                  </div>
                  <div>
                    <h5 className="font-semibold text-gray-800 mb-1">주소</h5>
                    <p className="text-gray-600">전라남도 고흥군 치유마을길 123</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-green-600 text-xl"></i>
                  </div>
                  <div>
                    <h5 className="font-semibold text-gray-800 mb-1">전화번호</h5>
                    <p className="text-gray-600">061-830-5000</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-green-600 text-xl"></i>
                  </div>
                  <div>
                    <h5 className="font-semibold text-gray-800 mb-1">이메일</h5>
                    <p className="text-gray-600">info@goheung-dreamtree.com</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-green-600 text-xl"></i>
                  </div>
                  <div>
                    <h5 className="font-semibold text-gray-800 mb-1">운영시간</h5>
                    <p className="text-gray-600">
                      평일: 오전 9시 ~ 오후 6시<br />
                      주말: 오전 9시 ~ 오후 7시<br />
                      <span className="text-sm text-gray-500">점심시간: 12시 ~ 1시</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Transportation */}
            <div>
              <h4 className="text-xl font-bold text-gray-800 mb-4">교통편 안내</h4>
              <div className="bg-green-50 rounded-xl p-6">
                <div className="space-y-4">
                  <div>
                    <h5 className="font-semibold text-gray-800 mb-2">
                      <i className="ri-car-line mr-2 text-green-600"></i>
                      자가용 이용시
                    </h5>
                    <p className="text-gray-600 text-sm">
                      • 서울에서: 경부고속도로 → 호남고속도로 → 고흥IC → 치유마을 (약 4시간)<br />
                      • 광주에서: 광주-순천고속도로 → 고흥IC → 치유마을 (약 1시간 30분)
                    </p>
                  </div>
                  
                  <div>
                    <h5 className="font-semibold text-gray-800 mb-2">
                      <i className="ri-bus-line mr-2 text-green-600"></i>
                      대중교통 이용시
                    </h5>
                    <p className="text-gray-600 text-sm">
                      • 고흥터미널에서 마을버스 이용 (1일 6회 운행)<br />
                      • 사전 연락시 고흥터미널에서 픽업 서비스 제공
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Map */}
          <div>
            <h4 className="text-2xl font-bold text-gray-800 mb-6">오시는 길</h4>
            <div className="bg-gray-100 rounded-2xl overflow-hidden shadow-lg">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3326.8!2d127.2734!3d34.6118!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzTCsDM2JzQyLjUiTiAxMjfCsDE2JzI0LjIiRQ!5e0!3m2!1sko!2skr!4v1234567890"
                width="100%"
                height="400"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="고흥꿈트리 치유마을 위치"
              ></iframe>
            </div>
            
            <div className="mt-6 grid grid-cols-2 gap-4">
              <button
                onClick={() => window.open('https://map.naver.com/v5/search/고흥꿈트리', '_blank')}
                className="flex items-center justify-center px-4 py-3 bg-green-500 hover:bg-green-600 text-white rounded-xl transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-map-line mr-2"></i>
                네이버 지도
              </button>
              <button
                onClick={() => window.open('https://map.kakao.com/link/search/고흥꿈트리', '_blank')}
                className="flex items-center justify-center px-4 py-3 bg-yellow-500 hover:bg-yellow-600 text-white rounded-xl transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-map-2-line mr-2"></i>
                카카오맵
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}